import capitalize from './capitalize'
import uppercase from './uppercase'
import lowercase from './lowercase'
import placeholder from './placeholder'

export {
  capitalize,
  uppercase,
  lowercase,
  placeholder
}


// WEBPACK FOOTER //
// core-build-local/filters/string/index.js